import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import {
  ApplicationConfig,
  provideAppInitializer,
  inject,
  provideBrowserGlobalErrorListeners,
} from '@angular/core';
import { provideRouter } from '@angular/router';
// import { LoginMediaManager } from './features/auth-media/login-media/login-media-manager';
import { routes } from './app.routes';
import { ShamDashboardData } from 'sham-components/features/dashboard';
import { dashboardLayoutDataFactory } from './services/dashboardDataFactory';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  AppEnvironment,
  provideSignalrNotifications,
} from 'sham-components/services';
import { API_BASE_URL } from '@/environments/environment';
import { provideTranslateService } from '@ngx-translate/core';
import { appEnvFactory } from '@/app/services/appEnvFactory';
import { authInterceptor } from './services/auth.interceptor';
import { firstValueFrom } from 'rxjs';
import { AuthService } from './services/auth.service';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(routes),

    // provideSignalrNotifications({
    //   hubUrl: `${API_BASE_URL}/hubs/notifications`,
    //   accessTokenFactory: () => globalThis.localStorage.getItem('token') ?? '',
    //   notificationEventNames: ['NotificationReceived'],
    //   enableAutomaticReconnect: true,
    // }),

    provideTranslateService({
      defaultLanguage: 'en',
      fallbackLang: 'en',
      loader: provideTranslateHttpLoader({
        prefix: '/assets/',
        suffix: '.json',
        useHttpBackend: true,
      }),
    }),

    provideAppInitializer(() => {
      const appEnv = inject(AppEnvironment);
      const authService = inject(AuthService);
      const dashboardService = inject(ShamDashboardData);

      return appEnvFactory(appEnv).then(() =>
        Promise.allSettled([
          firstValueFrom(authService.processRefreshVerification()),
          dashboardLayoutDataFactory(dashboardService),
        ]),
      );
    }),

    provideHttpClient(withInterceptors([authInterceptor])),
  ],
};
